// extracted by mini-css-extract-plugin
export default {"title":"index_title_5Z2Mn","box":"index_box_Nt5Dk clearfix"};